export default __webpack_public_path__ + "static/media/saleshandy-logo-icon.4af46bf1.svg";